import { Box, Grid, Link, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import useNotify from "../../unit/useNotify";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import HeaderLabelGridField from "../../unit/HeaderLabelGridField";
import PaperComponent from "../../unit/PaperComponent";

export default function CustomLoanPostponeDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [submitTitle, setSubmitTitle] = React.useState("Confirm");
  const lastDate = record?.lastDate;
  const accruedInterestAmount = record?.accruedInterestAmount;
  const nextPaymentAmount = record?.loan?.nextPaymentAmount;
  const showSkipExtend = record?.showSkipExtend ? true : false;

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const nextPaymentDate = dayjs
    .tz(record?.loan?.nextPaymentDate, "America/New_York")
    .format("YYYY-MM-DD");
  if (
    record?.largeExtendDate == undefined ||
    record?.largeExtendDate == "" ||
    record?.largeExtendDate == null
  ) {
    //nextPaymentDate + 23 days
    record.largeExtendDate = dayjs(nextPaymentDate)
      .add(23, "day")
      .format("YYYY-MM-DD");
  }
  const newPaymentDate = dayjs
    .tz(record?.largeExtendDate, "America/New_York")
    .format("YYYY-MM-DD");
  let curPaymentFrequency = record?.loan?.paymentFrequency;
  // let newDefaultMaturityDate = record?.loan?.maturityDate;
  let newDefaultMaturityDate = dayjs
    .tz(record?.loan?.maturityDate, "America/New_York")
    .format("YYYY-MM-DD");
  if (
    curPaymentFrequency == "Monthly" ||
    curPaymentFrequency == "Single Repayment"
  ) {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(1, "month")
      .format("YYYY-MM-DD");
  } else if (curPaymentFrequency == "Bi-Weekly") {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(2, "week")
      .format("YYYY-MM-DD");
  } else if (curPaymentFrequency == "Weekly") {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(1, "week")
      .format("YYYY-MM-DD");
  } else if (curPaymentFrequency == "Semimonthly") {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(15, "day")
      .format("YYYY-MM-DD");
  }

  const [newMaturityDate, setNewMaturityDate] = React.useState(
    newDefaultMaturityDate
  );
  const [open, setOpen] = React.useState(false);
  const [formSubData, setFormSubData] = React.useState({
    notes: "",
    type: "postpone",
    update_scheduled_payment_comment: "",
    payment_date: "",
    paid_date: "",
    adjust_payment_date: "",
    adjust_payment_amount: "",
  });
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSubmitTitle("Confirm");
    // refresh();
  };
  const handleRefreshFun = () => {
    refresh();
  };
  if (showSkipExtend == false) {
    return (
      <Link
        id="link-loan-postpone-next-payment"
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
          color: "grey",
        }}
      >
        Postpone Next Payment
      </Link>
    );
  }
  return (
    <React.Fragment>
      {/* <Button
          label="Postpone Due Date"
          variant="text"
          size="medium"
          // color="error"
          sx={{
            marginLeft: "10px",
            "&:hover": {
              background: "none",
            },
          }}
          disabled={!showSkipExtend}
          onClick={handleClickOpen}
        /> */}
      <Link
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
        }}
        onClick={handleClickOpen}
      >
        Postpone Next Payment
      </Link>
      <Dialog
        id="dialog-loan-postpone-due-date"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();

            const formJson = {
              type: "postpone",
              update_scheduled_payment_comment: formSubData.notes,
              payment_date: newPaymentDate,
              paid_date: "",
              adjust_payment_date: "",
              adjust_payment_amount: "",
            };
            setSubmitTitle("loading");
            const reqUrl = `update/payment/schedule`;
            const responseBack = await sendRequest(reqUrl, {
              id: record?.curPV?.iId,
              data: formJson,
            });
            console.log(responseBack.data);
            if (responseBack && responseBack.code == "200") {
              successNotify("Data saved successfully");
              handleRefreshFun();
              handleClose();
              // refresh();
            } else {
              if (responseBack?.message != undefined) {
                errorNotify(responseBack.message);
              } else {
                errorNotify(responseBack?.message || "Data not saved!");
              }
            }
            setSubmitTitle("Confirm");
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle
            title={`${record?.loan?.loanStatus} Loan`}
            subTitle="Postpone Next Payment"
          />
        </DialogTitle>
        <DialogContent>
          <Box>
            <DialogContentText>
              This function postpones the Next Payment Due Date to 7 days before
              the following Payment Due Date. Interest will continue to accrue
              during the extended period, resulting in an increase to the last
              scheduled payment amount. Available only for loans that are
              current and can only be applied before the end of Payment Grace
              Period.
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ my: 2, color: "red" }}
              >
                Resetting payment schedule of any kind is limited to only once
                per day. This change is irreversible. Please check all the
                inputs and carefully preview the results before clicking
                “Confirm” to commit the changes.
              </Typography>
              <Grid container>
                <Grid item xs={3}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="Payment ID"
                    value={record?.curPV?.iId}
                    className="numericText"
                  />
                </Grid>
                <Grid item xs={3}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="Amount Scheduled"
                    value={
                      nextPaymentAmount ? formatCurrency(nextPaymentAmount) : ""
                      // invoiceAmount ? formatCurrency(nextPaymentAmount) : ""
                    }
                    className="amountText"
                  />
                </Grid>
                <Grid item xs={3}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="Current Scheduled Date"
                    value={nextPaymentDate ? formatDate(nextPaymentDate) : ""}
                    className="dateText"
                  />
                </Grid>
                <Grid item xs={3}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="New Payment Date"
                    value={newPaymentDate ? formatDate(newPaymentDate) : ""}
                    className="dateText"
                  />
                </Grid>
                <Grid item xs={3} sx={{ mt: 1 }}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="Current Remaining Payments"
                    value={record?.loan?.remainingPayments}
                    className="numericText"
                  />
                </Grid>
                <Grid item xs={3} sx={{ mt: 1 }}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="New Remaining Payments"
                    value={record?.loan?.remainingPayments}
                    className="numericText"
                  />
                </Grid>
                <Grid item xs={3} sx={{ mt: 1 }}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="Current Maturity Date"
                    value={
                      record?.loan?.maturityDate
                        ? formatDate(record?.loan?.maturityDate)
                        : ""
                    }
                    className="numericText"
                  />
                </Grid>
                <Grid item xs={3} sx={{ mt: 1 }}>
                  <HeaderLabelGridField
                    dxs={12}
                    tdxs={12}
                    title="New Maturity Date"
                    value={
                      record?.loan?.maturityDate
                        ? formatDate(record?.loan?.maturityDate)
                        : ""
                    }
                    className="dateText"
                  />
                </Grid>
              </Grid>
            </DialogContentText>
            <Grid container sx={{ mb: 0, mt: 2, pb: 0 }}>
              <Grid sx={{ mb: 0 }} container>
                <HeaderLabelTitle
                  title="Add Note (Max 150 Characters)"
                  suffix=""
                />
              </Grid>
              <Grid sx={{ mb: 0 }} container>
                <TextField
                  id="notes"
                  name="notes"
                  value={formSubData.notes}
                  onChange={(e) => {
                    setFormSubData({
                      ...formSubData,
                      notes: e.target.value,
                    });
                  }}
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  placeholder="Notes"
                  multiline={true}
                  minRows={2}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit
            label={submitTitle}
            variant="contained"
            disabled={submitTitle == "loading" ? true : false}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
